export default __webpack_public_path__ + "99d22ac.png";